// @flow

import { combineEpics, ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import config from '../../config/app.config.js';
import { paypalDataToUserTypeAdapter } from '../../modules/paypalconnect';
import { API } from '../../utils/APIUtils';
import { getCookie } from '../../utils/CommonUtils';
import {
  WS_GET_PAYPAL_LOGIN_URL_REQUEST,
  WS_GET_PAYPAL_REQUEST_ERROR,
  WS_GET_PAYPAL_LOGIN_URL_REQUEST_SUCCESS,
  WS_GET_PAYPAL_USER_DATA_REQUEST,
  WS_GET_PAYPAL_USER_DATA_REQUEST_SUCCESS,
} from '../actions';
import type { UserRegistrationActions, MessageResponse, PaypalUserData } from '../types';

import { afterInitRegistration } from './userRegistrationEpics';
import { sendMessage } from './websocketEpics';

const paypalConnectGetUrlEpic = (
  action$: ActionsObservable<UserRegistrationActions>,
  state$: any,
) =>
  action$.pipe(
    filter(action => action.type === WS_GET_PAYPAL_LOGIN_URL_REQUEST && !config.isMockUp),
    afterInitRegistration(state$, (actionSend: UserRegistrationActions) => {
      if (actionSend.type === WS_GET_PAYPAL_LOGIN_URL_REQUEST) {
        const jwt = getCookie(config.nameCookieJWT);

        return sendMessage({
          params: {
            jwt,
          },
          method: API.GetPaypalLoginUrl,
        }).pipe(
          switchMap((payload) => {
            if (payload.error || !payload.result) {
              return of({
                type: WS_GET_PAYPAL_REQUEST_ERROR,
                payload: payload,
              });
            }
            return of({
              type: WS_GET_PAYPAL_LOGIN_URL_REQUEST_SUCCESS,
              payload: payload.result,
            });
          }),
        );
      }
      return null;
    }),
  );

const paypalConnectGetUserDataEpic = (
  action$: ActionsObservable<UserRegistrationActions>,
  state$: any,
) =>
  action$.pipe(
    filter(action => action.type === WS_GET_PAYPAL_USER_DATA_REQUEST && !config.isMockUp),
    afterInitRegistration(state$, (actionSend: UserRegistrationActions) => {
      const jwt = getCookie(config.nameCookieJWT);

      if (actionSend.type === WS_GET_PAYPAL_USER_DATA_REQUEST) {
        return sendMessage({
          params: {
            authorization_code: actionSend.payload,
            jwt,
          },
          method: API.GetUserDataFromPaypal,
        }).pipe(
          switchMap((payload: MessageResponse<{ result: PaypalUserData }, { error: any }>) => {
            if (payload.error) {
              return of({
                type: WS_GET_PAYPAL_REQUEST_ERROR,
                payload: payload.error,
              });
            }
            return of({
              type: WS_GET_PAYPAL_USER_DATA_REQUEST_SUCCESS,
              payload: paypalDataToUserTypeAdapter(payload.result),
            });
          }),
        );
      }
      return null;
    }),
  );

export const paypalConnectEpics = combineEpics(
  paypalConnectGetUrlEpic,
  paypalConnectGetUserDataEpic,
);
